import { render, staticRenderFns } from "./HorizontalScroller.vue?vue&type=template&id=428ab030&"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScroller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports